// User Component imports
import {Row, Button} from "_core/components/common/UI";

// styles imports
import './Tab.scss';

export const Comment = `
	/**
	 *
	 * props の定義
	 *
	 * [data-*]
	 * 		dataset			... [act] で指定の処理から e.target.dataset.json として呼び出したいJSON文字列
	 * [set]
	 * 		id				...	スタイルシートid指定の文字列
	 * 		class			...	スタイルシートクラス指定の文字列
	 * 		disabled		...	disabled 属性の指定のフラグ
	 * 		value		...	ボタンに表示する文字列
	 *
	 * [act]
	 * 		onclick			...	クリック時に実行したい処理
	 * 		onmousedown		...	クリック時にonBlurより先に実行したい処理
	 */
	`

export const Tab = (props) => {
	// // コンポーネントの返却
	// if (props.isLoading)
	// {
	// 	return (
	// 	<div className={"button loading " + props.className}>{props.children}</div>
	// 	);
	// }

	return (
		<Row className={"tab spacing-8px" + (props.className ? props.className : "")}>
			{props.tabDataList.map((tabData) => {
				return (
					<Button 
						className={"tab-button white " + (tabData.selected ? "selected" : "")}
						onClick={() => {tabData.onClick()}}
					>
						{tabData.label}
					</Button>
			)})}
		</Row>
	);
}
export default Tab